import React, { useState } from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import FirstStep from "./FirstStep";
import SecondStep from "./SecondStep";
import ThirdStep from "./ThirdStep";
import logo from "../../assets/img/retail-logo-trans.png";
import { useNavigate } from "react-router-dom";

const steps = ["Step 1", "Step 2", "Step 3"];
const steplabel = [
  "Vendor Details",
  "Vendor Contacts",
  "Submit",
  // "Set Credentials",
];

export default function Main() {
  const navigate = useNavigate();

  const [activeStep, setActiveStep] = useState(0);
  const [completed, setCompleted] = useState({});
  const [formData, setFormData] = useState({});
  const [resendCount, setResendCount] = useState(0);

  const resetForm = () => {
    setCompleted({});
    setActiveStep(0);
    setFormData({});
    setResendCount(0);
  };

  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleComplete = () => {
    const newCompleted = completed;
    newCompleted[activeStep] = true;
    setCompleted(newCompleted);
    handleNext();
  };

  const selectStep = (index) => {
    switch (index) {
      case 0: {
        return (
          <FirstStep
            onClickNext={handleComplete}
            formData={formData}
            setFormData={setFormData}
            handleBack={handleBack}
          />
        );
      }
      case 1: {
        return (
          <SecondStep
            onClickNext={handleComplete}
            formData={formData}
            setFormData={setFormData}
            handleBack={handleBack}
            resendCount={resendCount}
          />
        );
      }
      case 2: {
        return (
          <ThirdStep
            onClickNext={handleComplete}
            formData={formData}
            setFormData={setFormData}
            handleBack={handleBack}
            resendCount={resendCount}
            resetForm={resetForm}
            setResendCount={setResendCount}
          />
        );
      }

      default:
        return (
          <FirstStep
            onClickNext={handleComplete}
            formData={formData}
            setFormData={setFormData}
            handleBack={handleBack}
          />
        );
    }
  };
  return (
    <Box sx={{ width: "100%" }}>
      <div className="stepperFormHeader">
        <div className="stepper-col-1">
          <div
            className="logoContainer"
            onClick={() => {
              navigate("/");
            }}
          >
            <img
              src={logo}
              alt="reliance retail"
              title="Dock Appointment System"
              width="90"
              height="45"
            />
            <div className="projectLogo fontSize20">
              <div title="Dock Appointment System">DAS New</div>
              <div className="projectTitle">Dock Appointment System</div>
            </div>
          </div>
        </div>
        <div className="stepper-col-2">
          <Stepper
            nonLinear
            activeStep={activeStep}
            alternativeLabel
            className="stepMain"
          >
            {steps.map((label, index) => (
              <Step key={label} completed={completed[index]} sx={{ mt: 0 }}>
                <StepLabel sx={{ mt: 0 }}>
                  <span className="stepLabel">{label}</span>
                  <br />
                  <span className="stepsubLabel"> {steplabel[index]}</span>
                </StepLabel>
              </Step>
            ))}
          </Stepper>
        </div>
      </div>
      <div className="stepperFormTitle">
        {activeStep === 4 ? "Vendor Details Preview" : "Vendor Registration"}
      </div>
      {selectStep(activeStep)}
    </Box>
  );
}
